import { useState } from 'react';
import { faqItems } from '@/mocks/data';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Sık Sorulan Sorular
          </h2>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 transition-colors ${openId === faq.id ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-sm w-4 h-4 flex items-center justify-center ${openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}